var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 35.0013C17.5871 35.0013 18.3333 34.2551 18.3333 33.3346C18.3333 32.4142 17.5871 31.668 16.6667 31.668C15.7462 31.668 15 32.4142 15 33.3346C15 34.2551 15.7462 35.0013 16.6667 35.0013Z",
    stroke: "#0B0C0E",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 35.0013C30.9204 35.0013 31.6666 34.2551 31.6666 33.3346C31.6666 32.4142 30.9204 31.668 29.9999 31.668C29.0794 31.668 28.3333 32.4142 28.3333 33.3346C28.3333 34.2551 29.0794 35.0013 29.9999 35.0013Z",
    stroke: "#0B0C0E",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 5H9.16659C9.16659 5 9.85482 8.04738 10.2958 10C11.177 13.9016 12.3872 19.2603 13.0972 22.4042C13.4404 23.9238 14.7899 25 16.3479 25H30.6594C32.2218 25 33.5744 23.9148 33.9133 22.3898L36.6666 10",
    stroke: "#0B0C0E",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6666 10H10.8333",
    stroke: "#0B0C0E",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.5c894ec704d0239c3881d1bf292d1eed.svg";
export { ForwardRef as ReactComponent };